<account-back>{{content.title | translate}}</account-back>

<div class="_account-information-centre-grid w-10 w-12-m w-12-s">
    @for (item of itemsWithPublishedLinks; track $index; let i = $index) {
    @if (!item.hide) {
    <section2 [sectionTitle]="item.title"
              class="_account-dashboard-card">
        <p class="p1 col-11 ">{{item.message}}</p>
        @if (item.visibleLinks.length) {
        <div class="m-t-6">
            @for (link of item.visibleLinks; track $index) {
            <href class="m-b-6 block"
                  [link]="link.url">
                <button class="button-inline-2 ">{{link.linkText}}</button>
            </href>
            }
            <div [hideUp]="['information-centre', i]">
                @for (link of item.hiddenLinks; track $index) {
                <href class="m-b-6 block"
                      [link]="link.url">
                    <button class="button-inline-2">{{link.linkText}}</button>

                </href>
                }
            </div>
        </div>
        }
        @if (item.hiddenLinks.length) {
        <button class="button m-t-1"
                [toggle]="['information-centre', i]">
            <span [toggleClass]="'ng-hide'"
                  [toggleClassBy]="['information-centre', i]">{{'View More' | translate}}</span>
            <span [toggleClass]="'!ng-hide'"
                  [toggleClassBy]="['information-centre', i]">{{'Hide' | translate}}</span>
        </button>
        }
    </section2>
    }
    }
</div>